export const isUnixSystem = () =>
  /(Mac|Linux)/i.test(window.navigator.platform);

export const isWindowsSystem = () => /(Win)/i.test(window.navigator.platform);
